module.exports = __webpack_public_path__ + "static/media/right2.c9a377cb.svg";